export default "__VITE_ASSET__GoIlRjt1__"